export default __webpack_public_path__ + "static/media/blueTheme-boy.b2f186cb.svg";